const zips = {
  52500: true,
  52503: true,
  52504: true,
  52506: true,
  52760: true,
  52763: true,
  52764: true,
  52765: true,
  52766: true,
  52767: true,
  52768: true,
  52769: true,
  52770: true,
  52773: true,
  52774: true,
  52775: true,
  52776: true,
  52777: true,
  52778: true,
  52779: true,
  52780: true,
  52783: true,
  52784: true,
  52785: true,
  52786: true,
  52787: true,
  52788: true,
  52789: true,
  52790: true,
  52793: true,
  52794: true,
  52795: true,
  52796: true,
  52797: true,
  52798: true,
  52799: true,
  52900: true,
  52910: true,
  52915: true,
  52916: true,
  52918: true,
  52919: true,
  52920: true,
  52923: true,
  52924: true,
  52925: true,
  52926: true,
  52927: true,
  52928: true,
  52929: true,
  52930: true,
  52934: true,
  52936: true,
  52937: true,
  52938: true,
  52940: true,
  52945: true,
  52946: true,
  52947: true,
  52948: true,
  52949: true,
  52950: true,
  52953: true,
  52957: true,
  52959: true,
  52960: true,
  52965: true,
  52966: true,
  52967: true,
  52968: true,
  52970: true,
  52975: true,
  52976: true,
  52977: true,
  52978: true,
  52979: true,
  52980: true,
  52985: true,
  52986: true,
  52987: true,
  52988: true,
  52989: true,
  52990: true,
  52994: true,
  52995: true,
  52996: true,
  52997: true,
  52998: true,
  53000: true,
  53010: true,
  53030: true,
  53040: true,
  53050: true,
  53060: true,
  53070: true,
  53100: true,
  53110: true,
  53115: true,
  53116: true,
  53117: true,
  53119: true,
  53120: true,
  53124: true,
  53125: true,
  53126: true,
  53127: true,
  53128: true,
  53129: true,
  53130: true,
  53138: true,
  53140: true,
  53150: true,
  53160: true,
  53170: true,
  53177: true,
  53178: true,
  53200: true,
  53215: true,
  53216: true,
  53217: true,
  53218: true,
  53219: true,
  53220: true,
  53224: true,
  53227: true,
  53228: true,
  53229: true,
  53230: true,
  53237: true,
  53239: true,
  53240: true,
  53247: true,
  53248: true,
  53250: true,
  53260: true,
  53270: true,
  53278: true,
  53279: true,
  53280: true,
  53283: true,
  53290: true,
  53296: true,
  53297: true,
  53298: true,
  53300: true,
  53309: true,
  53310: true,
  53320: true,
  53329: true,
  53330: true,
  53338: true,
  53339: true,
  53340: true,
  53348: true,
  53350: true,
  53370: true,
  53378: true,
  53390: true,
  53398: true,
  53400: true,
  53410: true,
  53420: true,
  53425: true,
  53426: true,
  53427: true,
  53428: true,
  53430: true,
  53440: true,
  53450: true,
  53458: true,
  53459: true,
  53460: true,
  53470: true,
  53489: true,
  53490: true,
  53500: true,
  53519: true,
  53520: true,
  53529: true,
  53530: true,
  53533: true,
  53550: true,
  53560: true,
  53569: true,
  53570: true,
  53580: true,
  53598: true,
  53640: true,
  53650: true,
  53658: true,
  53659: true,
  53660: true,
  53664: true,
  53670: true,
  53680: true,
  53687: true,
  53688: true,
  53689: true,
  53690: true,
  53694: true,
  53695: true,
  53696: true,
  53697: true,
  53698: true,
  53700: true,
  53708: true,
  53710: true,
  53713: true,
  53714: true,
  53716: true,
  53717: true,
  53718: true,
  53719: true,
  53730: true,
  53760: true,
  53770: true,
  53780: true,
  53787: true,
  53788: true,
  53790: true,
  53798: true,
  53799: true,
  53800: true,
  53809: true,
  53810: true,
  53819: true,
  53820: true,
  53830: true,
  53839: true,
  53840: true,
  53900: true,
  53909: true,
  53910: true,
  53930: true,
  53940: true,
  53950: true,
  53960: true,
  53970: true,
  54000: true,
  54009: true,
  54010: true,
  54015: true,
  54016: true,
  54017: true,
  54020: true,
  54021: true,
  54022: true,
  54023: true,
  54025: true,
  54026: true,
  54028: true,
  54030: true,
  54033: true,
  54037: true,
  54038: true,
  54040: true,
  54049: true,
  54050: true,
  54054: true,
  54055: true,
  54057: true,
  54059: true,
  54060: true,
  54063: true,
  54067: true,
  54068: true,
  54069: true,
  54070: true,
  54073: true,
  54075: true,
  54076: true,
  54080: true,
  54090: true,
  54092: true,
  54093: true,
  54094: true,
  54098: true,
  54100: true,
  54108: true,
  54109: true,
  54110: true,
  54118: true,
  54119: true,
  54120: true,
  54124: true,
  54126: true,
  54127: true,
  54128: true,
  54130: true,
  54134: true,
  54135: true,
  54136: true,
  54140: true,
  54142: true,
  54143: true,
  54145: true,
  54146: true,
  54147: true,
  54149: true,
  54150: true,
  54152: true,
  54158: true,
  54160: true,
  54162: true,
  54168: true,
  54170: true,
  54172: true,
  54173: true,
  54180: true,
  54187: true,
  54189: true,
  54190: true,
  54193: true,
  54195: true,
  54196: true,
  54197: true,
  54198: true,
  54700: true,
  54710: true,
};

let stepsCircles = document.querySelectorAll(".step-installment__circle");
let stepsDivs = document.querySelectorAll(".installation-steps-div");
let stepIndicator = document.getElementById("step-indicator");
let currentStep = 1;
function prevStep() {
  document.getElementById("next-step-btn").style.display = "block";
  if (currentStep > 1) {
    stepsCircles[currentStep - 1].classList.remove("step-installment__active");
    for (let i = 0; i < stepsDivs.length; i++) {
      stepsDivs[i].style.display = "none";
    }
    stepsDivs[currentStep - 2].style.display = "block";
    currentStep--;
    stepsCircles[currentStep - 1].classList.add("step-installment__active");
    stepIndicator.setAttribute("data-step-active", currentStep);
  }
  if (currentStep === 1) {
    document.getElementById("prev-step-btn").style.backgroundColor = "#ccc";
    document.getElementById("prev-step-btn").style.color = "#333";
  }
}
function nextStep() {
  document.getElementById("prev-step-btn").style.backgroundColor = "#76bc43";
  document.getElementById("prev-step-btn").style.color = "#fff";
  if (currentStep < stepsCircles.length) {
    stepsCircles[currentStep - 1].classList.remove("step-installment__active");
    for (let i = 0; i < stepsDivs.length; i++) {
      stepsDivs[i].style.display = "none";
    }
    stepsDivs[currentStep].style.display = "block";
    currentStep++;
    stepsCircles[currentStep - 1].classList.add("step-installment__active");
    stepIndicator.setAttribute("data-step-active", currentStep);
    if (currentStep === stepsCircles.length) {
      document.getElementById("next-step-btn").style.display = "none";
    } else {
      document.getElementById("next-step-btn").style.display = "block";
    }
  }
}
function validatePostalCode() {
  let code = document.getElementById("postal-code").value.trim();
  let message = document.getElementById("postal-code-message");
  let codeNum = parseInt(code, 10);
  let btn = document.getElementById("btn-validador");
  btn.disabled = true;
  btn.innerHTML = "Validando...";

  fetch("https://jeff-uxui.xyz/webhook/4f4caa29-4e91-42e1-9eca-1181a76f570c", {
    method: "POST",
    body: JSON.stringify({
      zip: codeNum,
      source: window.location,
    }),
    headers: {
      "content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      console.info("ZIP was saved successful", data);
    })
    .catch((e) => {
      console.error("ZIP could be saved");
    })
    .finally(() => {
      if (!/^\d{5}$/.test(code)) {
        message.textContent = "Ingresa un código postal válido de 5 dígitos.";
        message.style.color = "#e74c3c";
      } else if (codeNum >= 1000 && codeNum <= 16999) {
        document.getElementById("next-step-btn").disabled = false;
        message.textContent = "¡Sí contamos con instalación en tu zona!";
        message.style.color = "#76bc43";
      } else if (zips[code]) {
        document.getElementById("next-step-btn").disabled = false;
        message.textContent = "¡Sí contamos con instalación en tu zona!";
        message.style.color = "#76bc43";
      } else {
        message.textContent = "Por ahora no llegamos hasta ahí 😔";
        message.style.color = "#e74c3c";
      }
      btn.disabled = false;
      btn.innerHTML = "Validar";
    });
}

function validateCPAreaMetropolitan(num) {
  return (
    (num >= 1000 && num <= 16999) |
    (num >= 52900 && num <= 52999) |
    (num >= 54800 && num <= 54879) |
    (num >= 54700 && num <= 54769) |
    (num >= 55000 && num <= 55549) |
    (num >= 52760 && num <= 52799) |
    (num >= 53000 && num <= 53999) |
    (num >= 57000 && num <= 57999) |
    (num >= 54000 && num <= 54199)
  );
}
function toggleStepIcon(step) {
  var checkbox = document.getElementById("step" + step);
  var iconSpan = document.getElementById("icon-step" + step);
  if (checkbox.checked) {
    iconSpan.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#76bc43"/>
          <path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="2" fill="none"/>
        </svg>`;
  } else {
    iconSpan.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#ccc"/>
          <path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="2" fill="none"/>
        </svg>`;
  }
}
